import {
  Box,
  Button,
  Checkbox,
  CircularProgress,
  Container,
  DialogActions,
  FormControlLabel,
  Typography,
} from '@medely/web-components';
import { IProfessionalQualificationAttribute, IJob, OnboardingDocument } from '@medely/types';
import React, { useEffect, useState } from 'react';
import DocumentList from '../../../../components/DocumentList/DocumentList';
import Attribute from 'components/credentials/attributes/Attribute';
import { axios } from 'utils/networkRequests';
import { useTrackingQueryParams } from 'hooks/useTrackingQueryParams';
import BookJobContainer from 'components/jobActions/BookJobContainer';

type FacilityOnboardingProps = {
  canAttest?: boolean;
  completed?: boolean;
  source: string;
  documents: OnboardingDocument[];
  attributes?: Partial<IProfessionalQualificationAttribute>[];
  job?: IJob;
  isLoading?: boolean;
  onButtonClick?: () => void;
};

const FacilityOnboarding = ({
  canAttest = false,
  completed = false,
  source,
  documents,
  attributes,
  job,
  isLoading = false,
  onButtonClick,
}: FacilityOnboardingProps) => {
  const [attestChecked, setAttestChecked] = useState(false);
  const [isAcceptAndSignButtonLoading, setAcceptAndSignButtonLoading] = useState(false);
  const [viewCheckbox, setViewCheckbox] = useState(true);
  const { queryParams } = useTrackingQueryParams();
  const attestation_document = attributes?.find(
    (attr) => attr?.qualification_attribute?.field_type === 'expiration_date',
  );
  const expiration_date = attributes?.find(
    (attr) => attr?.qualification_attribute?.field_type === 'pdf',
  );

  useEffect(() => {
    const trackedEventURL = job
      ? `v3/professional/jobs/${job?.id}/tracking/onboarding_viewed`
      : `v3/professional/jobs/tracking/onboarding_viewed`;
    axios.post(trackedEventURL, {
      queryParams: { ...queryParams, source: source },
    });
  }, []);

  const handleAcceptAndSignButton = () => {
    setAcceptAndSignButtonLoading(true);
    onButtonClick?.();
  };

  // Keeping in case we go back to a multi-layered document list
  // const organizeDocuments = (docs) => {
  //   // If we want them alphabetically
  //   const sortedDocuments = docs.sort((a, b) => (a.name > b.name ? 1 : -1));
  //   const categorizedDocuments = {};
  //   sortedDocuments.forEach((doc) => {
  //     if (!categorizedDocuments[doc.category]) {
  //       categorizedDocuments[doc.category] = [doc];
  //     } else {
  //       categorizedDocuments[doc.category].push(doc);
  //     }
  //   });
  //   return categorizedDocuments;
  // };

  return (
    <Box>
      {isLoading ? (
        <CircularProgress />
      ) : (
        <>
          <DocumentList
            title="Facility Onboarding"
            documents={documents}
            onChangeLevel={(level: number) =>
              level === 0 ? setViewCheckbox(true) : setViewCheckbox(false)
            }
          />

          <FormControlLabel
            style={{
              display: canAttest && viewCheckbox ? 'table' : 'none',
              paddingBottom: '1rem',
            }}
            control={
              <div style={{ display: 'table-cell' }}>
                <Checkbox
                  color="primary"
                  value={attestChecked}
                  onChange={(_, checked) => {
                    setAttestChecked(checked);
                  }}
                />
              </div>
            }
            label={
              <>
                <Typography variant="body2" style={{ paddingBottom: '0.5rem' }}>
                  I have reviewed the facility onboarding documentation.
                </Typography>
              </>
            }
          />
          {canAttest &&
            viewCheckbox &&
            (job?.can_book_job ? (
              <Box
                position={'fixed'}
                left={0}
                right={0}
                bottom={0}
                zIndex={1}
                py={2}
                bgcolor={'background.paper'}
                boxShadow={4}
              >
                <Container maxWidth="sm">
                  <BookJobContainer
                    source="facility_confirmation"
                    job={job}
                    disabled={!attestChecked}
                  />
                </Container>
              </Box>
            ) : (
              <DialogActions>
                <Button
                  fullWidth
                  variant="contained"
                  color="primary"
                  onClick={handleAcceptAndSignButton}
                  disabled={!attestChecked || isAcceptAndSignButtonLoading}
                  loading={isAcceptAndSignButtonLoading}
                >
                  {'Accept & Sign'}
                </Button>
              </DialogActions>
            ))}
          {completed && attributes && (
            <Box>
              {!!attestation_document && (
                <Box mb={2} display="flex" justifyContent="space-between">
                  <Typography weight="medium" gutterBottom>
                    Expiration Date
                  </Typography>
                  <Attribute attribute={attestation_document} />
                </Box>
              )}
              {!!expiration_date && (
                <Box display="flex" justifyContent="right">
                  <Attribute attribute={expiration_date} />
                </Box>
              )}
            </Box>
          )}
        </>
      )}
    </Box>
  );
};

export default FacilityOnboarding;
